import { GridColDef } from '@mui/x-data-grid-pro';

import {
  DataGridColumnHeaderWithToolTip,
  DataGridStyledCellText,
} from '@verantos-dev/shared-components';
import { type CohortAttritionDetail } from '@verantos-dev/types-cohorts';

import { useCohortAttritionTableMessageKeys } from './useCohortAttritionTableMessageKeys';

export const useCohortAttritionColumns = () => {
  const messageKeys = useCohortAttritionTableMessageKeys();

  const commonColumnConfig: Partial<GridColDef<CohortAttritionDetail>> = {
    disableReorder: true,
    disableColumnMenu: true,
    sortable: false,
    filterable: false,
    renderCell: (renderCellParams) => {
      const isFinalRow = renderCellParams.row?.criterionName?.includes(
        'Total patients in the cohort'
      );
      const columnVal =
        isFinalRow && renderCellParams?.field === 'formattedSubjectsExcluded'
          ? '--'
          : renderCellParams.value;
      return (
        <DataGridStyledCellText fontWeight={isFinalRow ? 'bold' : undefined}>
          {columnVal || '--'}
        </DataGridStyledCellText>
      );
    },
  };

  const numbersColumnConfig: Partial<GridColDef<CohortAttritionDetail>> = {
    ...commonColumnConfig,
    align: 'right',
    headerAlign: 'right',
  };

  const columnConfig: GridColDef<CohortAttritionDetail>[] = [
    {
      ...commonColumnConfig,
      flex: 2,
      field: 'criterionName',
      headerName: messageKeys.criterion,
    },
    {
      ...numbersColumnConfig,
      field: 'formattedSubjectsRemaining',
      headerName: messageKeys.patientsRemaining,
      minWidth: 220,

      renderHeader: () => (
        <DataGridColumnHeaderWithToolTip
          id="attrition-table"
          headerName={messageKeys.patientsRemaining}
          description={messageKeys.patientsRemainingTooltip}
          placement="left"
        />
      ),
    },
    {
      ...numbersColumnConfig,
      field: 'subjectsRemainingPercent',
      headerName: messageKeys.patientsRemainingPercent,
    },
    {
      ...numbersColumnConfig,
      field: 'formattedSubjectsExcluded',
      headerName: messageKeys.patientsExcluded,
      minWidth: 220,
      renderHeader: () => (
        <DataGridColumnHeaderWithToolTip
          id="attrition-table"
          headerName={messageKeys.patientsExcluded}
          description={messageKeys.patientsExcludedTooltip}
          placement="left"
        />
      ),
    },
    {
      ...numbersColumnConfig,
      field: 'subjectsExcludedPercent',
      headerName: messageKeys.patientsExcludedPercent,
    },
  ];

  return columnConfig;
};
